let CancelToken;
let source;

const Config = require('~/config/default.env').default;
import { DEFAULT_FIELDS_BRAND } from '@/constant/fields';

export default {
  namespaced: true,
  state: {
    brands: [],
    country: [],
    categories: [],
    lists: [],
    lists_count: 0,
    trendingSearch: [],
    exclusiveAndTrendingTabs: {},
    exactSearch: {
      brand: true,
      product: true,
    },
  },
  mutations: {
    LISTS_COUNT(state, data) {
      state.lists_count = data;
    },
    MERGE_SEARCH_RESULT(state, data) {
      state.lists = state.lists.concat(data);
    },
    SET_BRANDS(state, brands) {
      state.brands = brands;
    },
    SET_COUNTRY(state, data) {
      state.country = data;
    },
    SET_CATEGORIES(state, categories) {
      state.categories = categories;
    },
    SET_SEARCH_RESULT(state, data) {
      state.lists = data;
    },
    SET_TRENDING_SEARCH(state, data) {
      state.trendingSearch = data;
    },
    SET_EXCLUSIVE_AND_TRENDING_TABS(state, data) {
      state.exclusiveAndTrendingTabs = data;
    },
    SET_EXACT_SEARCH(state, { key, value }) {
      state.exactSearch[key] = value;
    },
  },
  actions: {
    brands({ commit, state, dispatch, rootState }, { pages, filter, limit, is_elastic = false }) {
      const params = {
        filter: {
          name: { $regex: rootState.$_URI.queryString.q, $options: 'i' },
        },
        limit: rootState.$_URI.queryString.limit,
        skip: rootState.$_URI.queryString.skip,
        fields: DEFAULT_FIELDS_BRAND,
      };

      if (pages === 'tag-concern') {
        params.filter = {
          keyword: filter,
          elasticSearch: true,
          is_tag: true,
          is_active_in_sociolla: true,
        };
        params.limit = limit;
        delete params.skip;
      }
      if (is_elastic && pages !== 'tag-concern') {
        params.filter = {
          keyword: rootState.$_URI.queryString.q,
          elasticSearch: true,
        };
      }

      if (rootState.$_URI.queryString.sort) {
        params.sort = rootState.$_URI.queryString.sort;
      }

      if (rootState.$_URI.queryString.category) {
        params.filter['categories.id'] = {
          $in: rootState.$_URI.queryString.category,
        };
      }

      if (rootState.$_URI.queryString.prices) {
        const prices = rootState.$_URI.queryString.prices.split(',');
        params.filter['default_combination.price_after_discount'] = {
          $gte: Number(prices[0]),
          $lte: Number(prices[1]),
        };
      }

      if (rootState.$_URI.queryString.is_sale) {
        params.filter['is_sale'] = true;
      }

      if (rootState.$_URI.queryString.origins) {
        params.filter['brand.country_tag_id'] = {
          $in: rootState.$_URI.queryString.origins.split(','),
        };
      }

      if (rootState.$_URI.queryString.rating) {
        const rating = [];
        const filterQuery = rootState.$_URI.queryString.rating.split(',') || [];
        filterQuery.map((x) => {
          const intRating = Number(x);
          if (filterQuery.length > 1) {
            rating.push({
              'review_stats.average_rating': {
                $gte: intRating,
                $lte: intRating + 0.999,
              },
            });
          } else {
            rating.push({
              'review_stats.average_rating': { $gte: intRating },
            });
            rating.push({
              'review_stats.average_rating': { $lte: intRating + 0.999 },
            });
          }
        });
        if (filterQuery.length > 1) {
          params.filter['$and'] = [{ $or: rating }];
        } else {
          params.filter['$and'] = rating;
        }
      }

      if (rootState.$_URI.queryString.tags) {
        params.filter['tags.id'] = {
          $in: rootState.$_URI.queryString.tags.split(','),
        };
      }

      commit('SET_BRANDS', []);

      return axios
        .get(`${Config.MS_CATALOG_API_URL}/v3/brands/distinct/products`, {
          params: params,
        })
        .then((response) => {
          if (response.status === 200) {
            const list = response.data.data;
            list.forEach((brand, key) => {
              response.data.data[key].isHidden = false;
            });
            commit('SET_BRANDS', response.data.data);
            const result = [];
            const map = new Map();
            for (const item of list) {
              if (item.country && item.country_tag_id && !map.has(item.country)) {
                map.set(item.country, true);
                result.push(item);
              }
            }
            commit('SET_COUNTRY', result);
          } else {
            commit('SET_BRANDS', []);
            commit('SET_COUNTRY', []);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    categories({ commit, state, dispatch, rootState }, { pages, filter, limit }) {
      const params = {
        filter: {
          // name: { $regex: rootState.$_URI.queryString.q, $options: 'i' },
          keyword: rootState.$_URI.queryString.q,
          elasticSearch: true,
        },
        limit: rootState.$_URI.queryString.limit,
        skip: rootState.$_URI.queryString.skip,
      };

      if (pages === 'tag-concern') {
        params.filter = {
          keyword: filter,
          elasticSearch: true,
          is_tag: true,
          is_active_in_sociolla: true,
        };
        params.limit = limit;
        delete params.skip;
      }

      if (rootState.$_URI.queryString.sort) {
        params.sort = rootState.$_URI.queryString.sort;
      }

      commit('SET_CATEGORIES', []);

      return axios
        .get(`${Config.MS_CATALOG_API_URL}/v3/categories/distinct/products`, {
          params: params,
        })
        .then((response) => {
          if (response.status === 200) {
            const onlyParentCategory = [];
            if (response.data.data && response.data.data.length) {
              response.data.data.filter((category) => {
                if (category.parents.length === 1) {
                  onlyParentCategory.push(category);
                }
              });
            }
            commit('SET_CATEGORIES', onlyParentCategory);
          } else {
            commit('SET_CATEGORIES', []);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    search({ commit, state, dispatch, rootState }, { isLoadMore, pages, filter }) {
      const keyword = filter && filter.keyword ? filter.keyword : rootState.$_URI.queryString.q;
      if (!pages) {
        try {
          window.dataLayer.push({
            event: 'search',
            searchKeyword: keyword,
          });
        } catch (err) {
          console.log(err);
        }
      }

      const params = {
        filter: {
          keyword: keyword,
        },
        limit: rootState.$_URI.queryString.limit || 12,
        skip: rootState.$_URI.queryString.skip,
        // sort:'-total_orders'
      };

      if (pages === 'tag-concern') {
        params.filter = {
          keyword: keyword,
          is_tag: true,
        };
      }

      if (rootState.$_URI.queryString.sort) {
        params.sort = rootState.$_URI.queryString.sort;
        if (params.sort === '-is_sale,-default_combination.discount_amount') {
          // params.filter['default_combination.discount_amount'] = {"$ne":0}
        } else {
          if ('default_combination.discount_amount' in params.filter) {
            delete params.filter['default_combination.discount_amount'];
          }
        }
      }

      if (rootState.$_URI.queryString.brands) {
        params.filter['brand.id'] = {
          $in: rootState.$_URI.queryString.brands.split(','),
        };
      }

      if (rootState.$_Review.queryString.tags) {
        params.filter['tags.id'] = {
          $in: rootState.$_Review.queryString.tags.split(','),
        };
      }

      if (rootState.$_URI.queryString.category) {
        params.filter['categories.id'] = {
          $in: [`${rootState.$_URI.queryString.category}`],
        };
      }

      if (rootState.$_URI.queryString.prices) {
        const prices = rootState.$_URI.queryString.prices.split(',');
        params.filter['default_combination.price_after_discount'] = {
          $gte: Number(prices[0]),
          $lte: Number(prices[1]),
        };
      }

      if (rootState.$_URI.queryString.is_sale) {
        // params.filter['is_sale'] = true;
        params.filter['sale'] = true;
      }

      if (rootState.$_URI.queryString.products) {
        const product_filter = {
          all: false,
          is_pre_order: false,
          bundle: false,
        };
        rootState.$_URI.queryString.products.split(',').forEach((x) => {
          if (x === 'all_product') {
            product_filter.all = true;
          } else if (x == 'is_pre_order') {
            product_filter.is_pre_order = true;
          } else if (x == 'bundle') {
            product_filter.bundle = true;
          }
        });
        if (product_filter.is_pre_order) {
          params.filter['is_pre_order'] = true;
        } else if (product_filter.bundle) {
          params.filter['classification'] = 'bundle_virtual';
        }
      }

      if (rootState.$_URI.queryString.origins) {
        params.filter['brand.country_tag_id'] = {
          $in: rootState.$_URI.queryString.origins.split(','),
        };
      }

      if (rootState.$_URI.queryString.available_for) {
        const availableFor = rootState.$_URI.queryString.available_for.split(',');
        availableFor.forEach((t1, key) => {
          if (t1 == 'sociolla') {
            params.filter['is_active_in_sociolla'] = true;
          } else if (t1 == 'lulla') {
            params.filter['is_active_in_lulla'] = true;
          }
        });
      }

      if (rootState.$_URI.queryString.rating) {
        const rating = [];
        const filterQuery = rootState.$_URI.queryString.rating.split(',') || [];
        filterQuery.map((x) => {
          const intRating = Number(x);
          if (filterQuery.length > 1) {
            rating.push({
              'review_stats.average_rating': {
                $gte: intRating,
                $lte: intRating + 0.999,
              },
            });
          } else {
            rating.push({ $gte: intRating, $lte: intRating + 0.999 });
          }
        });
        if (pages === 'tag-concern') {
          if (rating.length) {
            params.filter['review_stats.average_rating'] = {};
          }
          rating.map((x) => {
            for (const [key, value] of Object.entries(x['review_stats.average_rating'])) {
              params.filter['review_stats.average_rating'][key] = value;
            }
          });
        } else {
          if (filterQuery.length > 1) {
            params.filter['$and'] = [{ $or: rating }];
          } else {
            params.filter['review_stats.average_rating'] = rating[0];
          }
        }
      }

      if (rootState.$_URI.queryString.tags) {
        params.filter['tags.name'] = {
          $in: rootState.$_URI.queryString.tags.split(','),
        };
      }

      params.filter.types = ['add-review'];
      if (Number(params.skip) === 0) {
        params.filter.types.push('brand');
      }
      params.filter.is_old_request = true;
      params.filter.is_old_response = false;

      dispatch('paramsTransformer', params);

      if (typeof source !== 'undefined') {
        source.cancel(false);
      }
      CancelToken = axios.CancelToken;
      source = CancelToken.source();

      // const searchEndpoint = `${Config.MS_CATALOG_API_URL}/v3/search`;
      const searchEndpoint = `${Config.MS_SOCO_PUBLIC_API_URL}/global-search`;
      const setExactSearch = (exactBrand = false, exactProduct = false) => {
        commit('SET_EXACT_SEARCH', {
          key: 'brand',
          value: exactBrand,
        });
        commit('SET_EXACT_SEARCH', {
          key: 'product',
          value: exactProduct,
        });
      };

      return axios
        .get(searchEndpoint, {
          params: params,
          cancelToken: source.token,
        })
        .then((response) => {
          if (response.status === 200) {
            if (isLoadMore) {
              commit('MERGE_SEARCH_RESULT', response.data.data['add-review']);
            } else {
              commit('SET_SEARCH_RESULT', response.data.data['add-review']);
            }
            setExactSearch(
              response.data.data.hasOwnProperty('exact_brand')
                ? response.data.data.exact_brand
                : Boolean(response.data.data.brand_count),
              response.data.data.exact_product
            );
            commit('LISTS_COUNT', response.data.data['add-review_count']);
          } else {
            if (isLoadMore) {
              commit('MERGE_SEARCH_RESULT', []);
            } else {
              commit('SET_SEARCH_RESULT', []);
            }
            setExactSearch();
          }
          return response;
        })
        .catch((error) => {
          if (isLoadMore) {
            commit('MERGE_SEARCH_RESULT', []);
          } else {
            commit('SET_SEARCH_RESULT', []);
          }
          setExactSearch();
          return error;
        });
    },
    paramsTransformer({ commit }, params) {
      /*
        //filter & sort mapper to match with request from apps
        //sort
        terlaris: -total_orders
        review: -review_stats.total_reviews
        harga rendah - tinggi: default_combination.price_after_discount
        harga tinggi - rendah: -default_combination.price_after_discount
        a - z: name
        z - a: -name

        //filter
        brand name: "brand.id":{"$in":["5d3ac303a6992471b7c973c1","5d3ac304a6992471b7c97566"]}
        brand origins: "brand.country_tag_id":{"$in":["17754","17769"]}
        rating: "review_stats.average_rating":{"$gte":5,"$lte":5.999}
        beauty profile: "tags.id":{"$in":["5e4ea2810dde1a0c012fc096","5ed8da4ffebd8598740b3e7a"]}
        sale: "is_sale":true
        pre-order: "is_pre_order":true
      */

      if (params.sort === '-total_orders') {
        params.sort = 'most-purchased';
      } else if (params.sort === '-review_stats.total_reviews') {
        params.sort = 'most-review';
      } else if (params.is_sale === true) {
        params.sort = '-default_combination.discount_amount';
      } else if (params.sort === 'default_combination.price_after_discount') {
        params.sort = 'cheapest';
      } else if (params.sort === '-default_combination.price_after_discount') {
        params.sort = 'expensive';
      } else if (params.sort === 'name') {
        params.sort = 'aToZ';
      } else if (params.sort === '-name') {
        params.sort = 'zToA';
      } else if (params.sort === '-_id') {
        params.sort = 'newest';
      } else {
        params.sort = '-is_active_in_sociolla -total_orders';
      }

      if (params.filter['categories.id']) {
        params.filter.category_id = params.filter['categories.id'];
        delete params.filter['categories.id'];
      }
      if (params.filter['default_combination.price_after_discount']) {
        params.filter.min_price = params.filter['default_combination.price_after_discount']['$gte'];
        params.filter.max_price = params.filter['default_combination.price_after_discount']['$lte'];
        delete params.filter['default_combination.price_after_discount'];
      }
    },
    searchV2({ commit, state, dispatch, rootState }, { isLoadMore, pages, filter }) {
      if (!pages) {
        try {
          window.dataLayer.push({
            event: 'search',
            searchKeyword: rootState.$_URI.queryString.q,
          });
        } catch (err) {
          console.log(err);
        }
      }

      const params = {
        filter: {
          keyword: rootState.$_URI.queryString.q,
        },
        limit: rootState.$_URI.queryString.limit,
        skip: rootState.$_URI.queryString.skip,
        // sort:'-total_orders'
      };

      if (pages === 'tag-concern') {
        params.filter = {
          keyword: filter,
          is_tag: true,
        };
      }

      if (rootState.$_URI.queryString.sort) {
        params.sort = rootState.$_URI.queryString.sort;
        if (params.sort === '-is_sale,-default_combination.discount_amount') {
          // params.filter['default_combination.discount_amount'] = {"$ne":0}
        } else {
          if ('default_combination.discount_amount' in params.filter) {
            delete params.filter['default_combination.discount_amount'];
          }
        }
      }

      if (rootState.$_URI.queryString.brands) {
        params.filter['brand.id'] = {
          $in: rootState.$_URI.queryString.brands.split(','),
        };
      }

      if (rootState.$_Review.queryString.tags) {
        params.filter['tags.id'] = {
          $in: rootState.$_Review.queryString.tags.split(','),
        };
      }

      if (rootState.$_URI.queryString.category) {
        params.filter['categories.id'] = {
          $in: [`${rootState.$_URI.queryString.category}`],
        };
      }

      if (rootState.$_URI.queryString.prices) {
        const prices = rootState.$_URI.queryString.prices.split(',');
        params.filter['default_combination.price_after_discount'] = {
          $gte: Number(prices[0]),
          $lte: Number(prices[1]),
        };
      }

      if (rootState.$_URI.queryString.is_sale) {
        params.filter['is_sale'] = true;
      }

      if (rootState.$_URI.queryString.products) {
        const product_filter = {
          all: false,
          is_pre_order: false,
          bundle: false,
        };
        rootState.$_URI.queryString.products.split(',').forEach((x) => {
          if (x === 'all_product') {
            product_filter.all = true;
          } else if (x == 'is_pre_order') {
            product_filter.is_pre_order = true;
          } else if (x == 'bundle') {
            product_filter.bundle = true;
          }
        });
        if (product_filter.is_pre_order) {
          params.filter['is_pre_order'] = true;
        } else if (product_filter.bundle) {
          params.filter['classification'] = 'bundle_virtual';
        }
      }

      if (rootState.$_URI.queryString.origins) {
        params.filter['brand.country_tag_id'] = {
          $in: rootState.$_URI.queryString.origins.split(','),
        };
      }

      if (rootState.$_URI.queryString.rating) {
        const rating = [];
        const filterQuery = rootState.$_URI.queryString.rating.split(',') || [];
        filterQuery.map((x) => {
          const intRating = Number(x);
          if (filterQuery.length > 1) {
            rating.push({
              'review_stats.average_rating': {
                $gte: intRating,
                $lte: intRating + 0.999,
              },
            });
          } else {
            rating.push({ $gte: intRating, $lte: intRating + 0.999 });
          }
        });
        if (pages === 'tag-concern') {
          if (rating.length) {
            params.filter['review_stats.average_rating'] = {};
          }
          rating.map((x) => {
            for (const [key, value] of Object.entries(x['review_stats.average_rating'])) {
              params.filter['review_stats.average_rating'][key] = value;
            }
          });
        } else {
          if (filterQuery.length > 1) {
            params.filter['$and'] = [{ $or: rating }];
          } else {
            params.filter['review_stats.average_rating'] = rating[0];
          }
        }
      }

      if (rootState.$_URI.queryString.tags) {
        params.filter['tags.id'] = {
          $in: rootState.$_URI.queryString.tags.split(','),
        };
      }

      params.filter.types = ['add-review'];
      params.filter.is_old_request = true;
      params.filter.is_old_response = false;

      dispatch('paramsTransformer', params);

      if (typeof source !== 'undefined') {
        source.cancel(false);
      }
      CancelToken = axios.CancelToken;
      source = CancelToken.source();

      // const searchEndpoint = `${Config.MS_CATALOG_API_URL}/v3/search`;
      const searchEndpoint = `${Config.MS_SOCO_PUBLIC_API_URL}/global-search`;

      return axios
        .get(searchEndpoint, {
          params: params,
          cancelToken: source.token,
        })
        .then((response) => {
          if (response.status === 200) {
            if (isLoadMore) {
              commit('MERGE_SEARCH_RESULT', response.data.data['add-review']);
            } else {
              commit('SET_SEARCH_RESULT', response.data.data['add-review']);
            }
          } else {
            if (isLoadMore) {
              commit('MERGE_SEARCH_RESULT', []);
            } else {
              commit('SET_SEARCH_RESULT', []);
            }
          }
          return response;
        })
        .catch((error) => {
          if (isLoadMore) {
            commit('MERGE_SEARCH_RESULT', []);
          } else {
            commit('SET_SEARCH_RESULT', []);
          }
          return error;
        });
    },
    searchCount({ commit, state, dispatch, rootState }, { pages, filter }) {
      const params = {
        filter: {
          keyword: rootState.$_URI.queryString.q,
        },
      };

      if (pages === 'tag-concern') {
        params.filter = {
          keyword: filter,
          is_tag: true,
        };
      }

      if (rootState.$_URI.queryString.sort) {
        params.sort = rootState.$_URI.queryString.sort;
        if (params.sort === '-is_sale,-default_combination.discount_amount') {
          // params.filter['default_combination.discount_amount'] = {"$ne":0}
        } else {
          if ('default_combination.discount_amount' in params.filter) {
            delete params.filter['default_combination.discount_amount'];
          }
        }
      }

      if (rootState.$_URI.queryString.brands) {
        params.filter['brand.id'] = {
          $in: rootState.$_URI.queryString.brands.split(','),
        };
      }

      if (rootState.$_Review.queryString.tags) {
        params.filter['tags.id'] = {
          $in: rootState.$_Review.queryString.tags.split(','),
        };
      }

      if (rootState.$_URI.queryString.category) {
        params.filter['categories.id'] = {
          $in: rootState.$_URI.queryString.category,
        };
      }

      if (rootState.$_URI.queryString.prices) {
        const prices = rootState.$_URI.queryString.prices.split(',');
        params.filter['default_combination.price_after_discount'] = {
          $gte: Number(prices[0]),
          $lte: Number(prices[1]),
        };
      }

      if (rootState.$_URI.queryString.is_sale) {
        params.filter['is_sale'] = true;
      }

      if (rootState.$_URI.queryString.origins) {
        params.filter['brand.country_tag_id'] = {
          $in: rootState.$_URI.queryString.origins.split(','),
        };
      }

      if (rootState.$_URI.queryString.rating) {
        const rating = [];
        const filterQuery = rootState.$_URI.queryString.rating.split(',') || [];
        filterQuery.map((x) => {
          const intRating = Number(x);
          if (filterQuery.length > 1) {
            rating.push({
              'review_stats.average_rating': {
                $gte: intRating,
                $lte: intRating + 0.999,
              },
            });
          } else {
            rating.push({
              'review_stats.average_rating': { $gte: intRating },
            });
            rating.push({
              'review_stats.average_rating': { $lte: intRating + 0.999 },
            });
          }
        });
        if (pages === 'tag-concern') {
          if (rating.length) {
            params.filter['review_stats.average_rating'] = {};
          }
          rating.map((x) => {
            for (const [key, value] of Object.entries(x['review_stats.average_rating'])) {
              params.filter['review_stats.average_rating'][key] = value;
            }
          });
        } else {
          if (filterQuery.length > 1) {
            params.filter['$and'] = [{ $or: rating }];
          } else {
            params.filter = { ...params.filter, ...rating[0] };
          }
        }
      }

      if (rootState.$_URI.queryString.tags) {
        params.filter['tags.id'] = {
          $in: rootState.$_URI.queryString.tags.split(','),
        };
      }

      return axios
        .get(`${Config.MS_CATALOG_API_URL}/v3/search/count`, {
          params: params,
        })
        .then((response) => {
          if (response.status == 200 && (response.data.data || response.data.data == 0)) {
            commit('LISTS_COUNT', response.data.data);
          }
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    searchCountV2({ commit }, data) {
      commit('LISTS_COUNT', data);
    },
    async fetchTrendingSearch({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          resolve(
            axios.get(`${this._vm.$customConfig.API.trendingSearch}`, {
              params: {
                limit: 5,
                skip: 0,
                sort: '-count',
              },
            })
          );
        } catch (error) {
          reject(error);
        }
      })
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            if (response.data.data.length <= 0) {
              commit('SET_TRENDING_SEARCH', ['skintific', 'cosrx', 'avoskin', 'esqa', 'azarine']);
            } else {
              commit('SET_TRENDING_SEARCH', response.data.data);
            }
          }
        })
        .catch((error) => {
          throw new Error(error);
        });
    },
    async fetchExclusiveAndTrendingTabs({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          resolve(
            axios.get(this._vm.$customConfig.API.suggestions, {
              params: {
                filter: {
                  types: ['new_exclusive', 'trending'],
                },
              },
            })
          );
        } catch (error) {
          reject(error);
        }
      })
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            commit('SET_EXCLUSIVE_AND_TRENDING_TABS', response.data.data);
            return response.data.data;
          }
        })
        .catch((error) => {
          throw new Error(error);
        });
    },
  },
};
